export const WEBHOOK_TYPES = [
    {
      value: 1,
      label: "webhook.ORDER_INFO_CALLBACK",
    },
    {
      value: 2,
      label: "webhook.INSPECTION_NOTICE",
    },
    {
      value: 3,
      label: "webhook.FINE_NOTICE",
    },
    {
      value: 100,
      label: "webhook.CUSTOMER_CRIMINAL_RECORD_CALLBACK",
    },
    {
      value: 101,
      label: "webhook.CUSTOMER_CRIMINAL_RECORD_UPDATE_CALLBACK",
    },
    {
      value: 102,
      label: "webhook.APP_USER_VEHICLE_NOTIFY_INFO_CALLBACK",
    },
    {
      value: 103,
      label: "webhook.CUSTOMER_RECORD_EXPIRATION_CALLBACK",
    },
    {
      value: 104,
      label: "webhook.SERVICE_PACKAGE_ACTIVATED_CALLBACK",
    },
    {
      value: 105,
      label: "webhook.SERVICE_PACKAGE_RENEWED_CALLBACK",
    },
    {
      value: 106,
      label: "webhook.SERVICE_PACKAGE_EXPIRED_CALLBACK",
    },
    {
      value: 200,
      label: "webhook.CUSTOMER_SCHEDULE_INFO_CALLBACK",
    },
    {
      value: 300,
      label: "webhook.RETRY_LOOKUP_VIOLATION_RESULT_CALLBACK",
    },
  ];